import { SudoPlatformLogo } from 'admin-web-ui'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Heading, SimplePage, SubHeading } from '../../components/SimplePage'
import { ForgotPasswordForm } from './ForgotPasswordForm'
import { VerificationAndNewPasswordForm } from './VerificationAndNewPasswordForm'

const StyledSudoPlatformLogo = styled(SudoPlatformLogo)`
  margin-bottom: 24px;
`

const StyledLink = styled(Link)`
  font-weight: 600;
`

type Status =
  | 'forgotPassword'
  | 'verifyAndChangePassword'
  | 'confirmPasswordChanged'

export const ForgotPassword = (): JSX.Element => {
  const [status, setStatus] = useState<Status>('forgotPassword')
  const [email, setEmail] = useState<string>('')

  return (
    <SimplePage>
      <StyledSudoPlatformLogo width={227} />
      {status === 'forgotPassword' ? (
        <>
          <Heading>Forgot password?</Heading>
          <SubHeading>Enter your email address</SubHeading>

          <ForgotPasswordForm
            onSubmit={(userEmail) => {
              setEmail(userEmail)
              setStatus('verifyAndChangePassword')
            }}
          />
        </>
      ) : status === 'verifyAndChangePassword' ? (
        <>
          <Heading>Check your email</Heading>
          <SubHeading>
            <span style={{ whiteSpace: 'nowrap' }}>
              Enter your validation code
            </span>{' '}
            <span style={{ whiteSpace: 'nowrap' }}>and new password</span>
          </SubHeading>
          <VerificationAndNewPasswordForm
            userEmail={email}
            onSubmit={() => setStatus('confirmPasswordChanged')}
          />
        </>
      ) : (
        <>
          <Heading>Password changed</Heading>
          <SubHeading>Your password has successfully been changed</SubHeading>
          <StyledLink to="/login">Back to Login</StyledLink>
        </>
      )}
    </SimplePage>
  )
}
